import { Alert, Button, Card, Icon, Typography } from 'antd';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { Bitrix24Consumer } from 'contexts/legacy/Bitrix24Context';
import { api } from 'services/api';

const { Text } = Typography;

function CallsExportView({ bitrix24 }) {
	const intl = useIntl();
	const t = (id) => intl.formatMessage({ id });

	const [exporting, setExporting] = useState(false);
	const [error, setError] = useState(null);

	const handleExport = async () => {
		setError(null);
		setExporting(true);

		try {
			const response = await api.get('calls/export', {
				params: {
					domain: bitrix24.auth.domain,
					b24_access_token: bitrix24.auth.access_token,
				},
				responseType: 'blob',
			});

			const blob = new Blob([response.data], { type: 'text/csv' });
			const url = URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = url;
			link.download = 'ligacoes.csv';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			URL.revokeObjectURL(url);
		} catch (err) {
			setError(err?.response?.data?.msg || err.message);
		} finally {
			setExporting(false);
		}
	};

	return (
		<div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: 16 }}>
			<Card style={{ maxWidth: 420, borderRadius: 12 }} bodyStyle={{ padding: 20 }}>
				<Text strong style={{ fontSize: 15, display: 'block', marginBottom: 8 }}>
					{t('calls_export_title')}
				</Text>
				<Text type="secondary" style={{ fontSize: 13, display: 'block', marginBottom: 16 }}>
					{t('calls_export_description')}
				</Text>
				<Button
					type="primary"
					loading={exporting}
					disabled={exporting}
					onClick={handleExport}
					style={{ borderRadius: 9999 }}
				>
					<Icon type="download" /> {t('calls_export_button')}
				</Button>
			</Card>

			{error && (
				<Alert
					type="error"
					showIcon
					message={error}
					style={{ borderRadius: 8, fontSize: 13, maxWidth: 420 }}
				/>
			)}
		</div>
	);
}

export default Bitrix24Consumer(CallsExportView);
